// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__VYI2u","modalForm":"UpgradeEpcsModal_modalForm__Rxcfs","modalFooter":"UpgradeEpcsModal_modalFooter__2A8xa"};